module.exports = require('./lib/effects')


//////////////////
// WEBPACK FOOTER
// ./~/redux-saga/effects.js
// module id = 71
// module chunks = 0